import React from "react";

function HomeSidebar({fill}) {
  return (
    <>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill='none'
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="ViewGridOutline">
        <path
          id="Vector"
          d="M3.33337 4.99998C3.33337 4.55795 3.50897 4.13403 3.82153 3.82147C4.13409 3.50891 4.55801 3.33331 5.00004 3.33331H6.66671C7.10873 3.33331 7.53266 3.50891 7.84522 3.82147C8.15778 4.13403 8.33337 4.55795 8.33337 4.99998V6.66665C8.33337 7.10867 8.15778 7.5326 7.84522 7.84516C7.53266 8.15772 7.10873 8.33331 6.66671 8.33331H5.00004C4.55801 8.33331 4.13409 8.15772 3.82153 7.84516C3.50897 7.5326 3.33337 7.10867 3.33337 6.66665V4.99998ZM11.6667 4.99998C11.6667 4.55795 11.8423 4.13403 12.1549 3.82147C12.4674 3.50891 12.8913 3.33331 13.3334 3.33331H15C15.4421 3.33331 15.866 3.50891 16.1786 3.82147C16.4911 4.13403 16.6667 4.55795 16.6667 4.99998V6.66665C16.6667 7.10867 16.4911 7.5326 16.1786 7.84516C15.866 8.15772 15.4421 8.33331 15 8.33331H13.3334C12.8913 8.33331 12.4674 8.15772 12.1549 7.84516C11.8423 7.5326 11.6667 7.10867 11.6667 6.66665V4.99998ZM3.33337 13.3333C3.33337 12.8913 3.50897 12.4674 3.82153 12.1548C4.13409 11.8422 4.55801 11.6666 5.00004 11.6666H6.66671C7.10873 11.6666 7.53266 11.8422 7.84522 12.1548C8.15778 12.4674 8.33337 12.8913 8.33337 13.3333V15C8.33337 15.442 8.15778 15.8659 7.84522 16.1785C7.53266 16.4911 7.10873 16.6666 6.66671 16.6666H5.00004C4.55801 16.6666 4.13409 16.4911 3.82153 16.1785C3.50897 15.8659 3.33337 15.442 3.33337 15V13.3333ZM11.6667 13.3333C11.6667 12.8913 11.8423 12.4674 12.1549 12.1548C12.4674 11.8422 12.8913 11.6666 13.3334 11.6666H15C15.4421 11.6666 15.866 11.8422 16.1786 12.1548C16.4911 12.4674 16.6667 12.8913 16.6667 13.3333V15C16.6667 15.442 16.4911 15.8659 16.1786 16.1785C15.866 16.4911 15.4421 16.6666 15 16.6666H13.3334C12.8913 16.6666 12.4674 16.4911 12.1549 16.1785C11.8423 15.8659 11.6667 15.442 11.6667 15V13.3333Z"
          stroke={fill}
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
    </svg>
    </>
   
  );
}

export default HomeSidebar;
